import { AuthAvailableTournament } from 'modules/auth/domain/interfaces/auth-available-tournament';
import { SportType } from 'modules/core/domain/enums/sport-type';

const getAvailableTournamentTypes = (tournaments: AuthAvailableTournament[]) => {
  return Object.keys(SportType).filter((type) => {
    return !tournaments.some((tournament) => tournament.sportType === type);
  });
};

export default getAvailableTournamentTypes;
